module.exports = __webpack_public_path__ + "images/mdi_material_design_2b6a6dfeb54ffef67d19f5b8ee2bea92.svg";